separatorIndex